<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditBranch"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editLocation"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Branch</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="">
              <div class="grid grid-cols-2 gap-5 items-center">
                <div class="text-sm">
                  <label class="block pb-1 text-xs">Branch Name</label>
                  <input
                    type="text"
                    name="location"
                    v-model="branchToEdit.Name"
                    id=""
                    class="p-2 bg-gray-200 rounded-full w-full"
                  />
                </div>
                <div class="text-sm">
                  <label class="block pb-1">Company</label>
                  <el-select
                    filterable
                    class="bg-gray-200 rounded-full w-full border-none"
                    v-model="branchToEdit.Location"
                    @change="findCountryByLocationName"
                    :default-first-item="true"
                    placeholder="Enter a country"
                  >
                    <el-option
                      v-for="location in locations"
                      :key="location.Name"
                      :label="location.Name"
                      :value="location.Name"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="text-sm col-span-2">
                  <label class="block pb-1 text-xs">Country</label>
                  <input
                    type="text"
                    name="location"
                    v-model="branchToEdit.Country"
                    id=""
                    disabled
                    class="p-2 bg-gray-200 rounded-full w-full"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupEditBranch",
  props: ["showEditBranch", "branchToEdit", "reload"],
  components: { Loader },
  data() {
    return {
      managerId: "",
      saved_locations: [],
      locations: [],
      selectedLocation: null,
      selectedLocationCountry: null,
      info: {
        Name: null,
      },

      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },
  created() {
    this.getLocations();
    //console.log(this.branchToEdit);
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async fetchLocations(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        this.location = this.locations.filter((location) =>
          location?.Name.toLowerCase().includes(queryString.toLowerCase())
        );
        //console.log(this.location)
        if (queryString && !this.location.length) {
          callback([{ Name: "No results found", Country: "No results found" }]);
          return;
        }
        callback(this.location);
      } else {
        callback(this.locations);
      }
    },

    findCountryByLocationName(selectedLocation) {
      this.selectedLocationId = this.locations.find(
        (location) => location.LocationName == selectedLocation
      ).Id;
      this.selectedLocationCountry = location.Country;
      this.branchToEdit.Country = this.selectedLocationCountry;
      //console.log(this.selectedLocationCountry)
    },

    // /{organization}/setup/location/v1/request
    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.locations = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    editLocation() {
      this.loading = true;
      //console.log(this.branchToEdit.Location, this.locations)
      // this.branchToEdit['']
      // //console.log(this.locations.map(location => //console.log(location)))

      this.selectedLocation = this.locations.find(
        (location) =>
          location.Name.trim().toLowerCase() ===
          this.branchToEdit.Location.trim().toLowerCase()
      );
      const locationId = this.selectedLocation.Id;
      this.branchToEdit["locationId"] = locationId;

      //console.log(this.selectedLocation)

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/edit`,
          JSON.stringify(this.branchToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.close();
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
